module.exports = __webpack_public_path__ + "img/sign_out.697660fb.svg";